import React, { useEffect, useState } from 'react'
import { useDataProvider, useNotify } from 'react-admin'
import { Typography } from '@mui/material'

export const TemplateVariables = ({ templateName, setMergeTags }) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const [variables, setVariables] = useState([])
  const [serviceTemplates, setServiceTemplates] = useState([])

  useEffect(() => {
    dataProvider
      .getList('serviceTemplates', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'id', order: 'ASC' },
      })
      .then(({ data }) => setServiceTemplates(data))
      .catch((error) => notify(`Error: ${error.message}`, { type: 'warning' }))
  }, [dataProvider, notify])

  useEffect(() => {
    if (templateName) {
      const indexServiceTemplates = serviceTemplates.findIndex(
        (template) => template.name === templateName
      )

      if (indexServiceTemplates !== -1) {
        const templateVar = serviceTemplates[indexServiceTemplates].variables
        setVariables(templateVar)

        const testMergeTags = templateVar.reduce((acc, key) => {
          acc[key] = key
          return acc
        }, {})

        setMergeTags(testMergeTags)
      } else {
        setVariables([])
        setMergeTags({})
      }
    } else {
      setVariables([])
      setMergeTags({})
    }
  }, [templateName, serviceTemplates, setMergeTags])

  return (
    <>
      <Typography mb={1} fontSize={'12px'}>
        Template variables
      </Typography>
      {variables.length > 0 && (
        <>
          <Typography mb={1} color={'slateblue'}>
            {variables.join(', ')}
          </Typography>
          <Typography mb={2} fontSize={'14px'}>
            Paste it inside <strong>{'{{'}</strong>
            variable
            <strong>{'}}'}</strong> to the mail text.
          </Typography>
        </>
      )}
      {!templateName && <Typography mb={2}>Please select template to see variables.</Typography>}
      {templateName && variables.length === 0 && (
        <Typography mb={2}>This template has no variables.</Typography>
      )}
    </>
  )
}
